import React, { useState, useContext, useEffect, Fragment } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Navigate } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@mui/styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  Add,
  ListOutlined,
  Search,
  Edit,
  HighlightOffOutlined,
  AddCircleOutline,
} from "@mui/icons-material";
import clsx from "clsx";
import { DataGrid, GridActionsCellItem, gridClasses } from "@mui/x-data-grid";
import axios from "axios";
import { TextField, Grid, Box, Alert, Card, Tooltip } from "@mui/material";
import Moment from "moment";

import EditClientsAdmin from "views/Dialog/EditClientsAdmin";
import NewClientsAdmin from "views/Dialog/NewClientsAdmin";
import StatusClientAdmin from "views/Dialog/StatusClientAdmin";
import TokenKeysAdmin from "views/Dialog/TokenKeysAdmin";

import loaderGif from "assets/img/loading.gif";
import noDataImg from "assets/img/undraw_House_searching_re_stk8.png";

import {
  cardBodyStyle,
  ButtonStyle0,
  ParagraphTextPage,
  blackColor,
  ButtonTableGrid1,
} from "components/cardBodyStyle";

// Crea un tema personalizado
const theme = createTheme({
  components: {
    MuiTablePagination: {
      styleOverrides: {
        displayedRows: {
          color: "black", // Cambia el color del texto a negro
        },
      },
    },
  },
});

const useStyles = makeStyles(cardBodyStyle);

export default function ClientsListAdmin() {
  const classes = useStyles();

  const [idRow, setIdRow] = useState("");
  const [rows, setRows] = useState([]);
  const [openStatus, setOpenStatus] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openNew, setOpenNew] = useState(false);
  const [loader, setLoader] = useState(true);
  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [returnLogin, setReturnLogin] = React.useState(false);
  const [openToken, setOpenToken] = React.useState(false);
  const [searchText, setSearchText] = useState("");
  const [rowsResponse, setRowsResponse] = useState([]);

  let resultSearch = "";

  const { urlServices, UserAuth } = useContext(UrlServicesContext);

  let keyAuthorization = UserAuth.Session;

  const [state] = useState({
    columns: [
      {
        headerName: "Cliente",
        field: "companyName",
        headerClassName: "super-app-theme--header",
        flex: 1,
        // headerAlign: "center",
        renderCell: (params) => {
          return <span style={{ fontSize: 14 }}>{params.value}</span>;
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        // align: "center",
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "Correo electrónico",
        field: "email",
        headerClassName: "super-app-theme--header",
        width: 300,
        // headerAlign: "center",
        renderCell: (params) => {
          return <span style={{ fontSize: 14 }}>{params.value}</span>;
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        // align: "center",
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "TOKEN",
        field: "action0",
        headerClassName: "super-app-theme--header",
        width: 120,
        headerAlign: "center",
        renderCell: (params) => {
          return (
            <Grid container>
              <Grid item xs={12} sm={12}>
                <ButtonTableGrid1
                  onClick={handleTokenValue(params)}
                  style={{
                    margin: "5px 0",
                    fontSize: 10,
                    width: 110,
                  }}
                >
                  Llave secreta
                </ButtonTableGrid1>
              </Grid>
            </Grid>
          );
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "Estado",
        field: "status",
        width: 120,
        headerAlign: "center",
        headerClassName: "super-app-theme--header",
        renderCell: (params) => {
          const text =
            params.value === 1
              ? "HABILITADO"
              : params.value === 2
                ? "PAUSADO"
                : "DESHABILITADO";
          const color =
            params.value === 1
              ? "success"
              : params.value === 2
                ? "warning"
                : "error";

          return (
            <Box sx={{ width: "100%", my: 1 }}>
              <Alert
                severity={color}
                icon={false}
                sx={{
                  width: "100%", // Ocupa el 100% del contenedor padre (Box)
                  py: 1, // Ajusta el padding vertical para compactar
                  px: 1, // Ajusta el padding horizontal
                  display: "flex",
                  justifyContent: "center", // Centra horizontalmente
                  alignItems: "center", // Centra verticalmente (opcional)
                  "& .MuiAlert-message": {
                    padding: 0, // Elimina el padding interno del mensaje
                    width: "100%", // Forzar ancho completo
                    textAlign: "center", // Centra el texto
                  },
                }}
              >
                <b style={{ color: color, fontSize: 10 }}>{text}</b>
              </Alert>
            </Box>
          );
        },
      },
      {
        headerName: "Creado",
        field: "createdAt",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          return (
            <span style={{ fontSize: 12 }}>
              {Moment(params.value).format("DD-MM-YYYY")}{" "}
            </span>
          );
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        width: 120,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "-----",
        field: "actions",
        type: "actions",
        width: 120,
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celActions: params.value,
          });
        },
        getActions: (params) => {
          const actions = [];

          actions.push(
            <Grid container>
              <Grid item xs={6} sm={6} md={6}>
                <GridActionsCellItem
                  key="edit"
                  icon={
                    <Tooltip title="Editar" arrow>
                      <Edit style={{ fontSize: 22, color: "#000" }} />
                    </Tooltip>
                  }
                  label="Editar"
                  onClick={openEditValue(params)}
                />
              </Grid>
              <Grid
                item
                xs={6}
                sm={6}
                md={6}
                sx={{
                  display: params.row.status === 0 ? "none" : "block",
                }}
              >
                <GridActionsCellItem
                  key="delete"
                  icon={
                    <Tooltip title="Deshabilitar" arrow>
                      <HighlightOffOutlined
                        style={{ fontSize: 24, color: "red" }}
                      />
                    </Tooltip>
                  }
                  label="Deshabilitar"
                  onClick={openStatusDeleteValue(params)}
                />
              </Grid>
              <Grid
                item
                xs={6}
                sm={6}
                md={6}
                sx={{
                  display: params.row.status === 0 ? "block" : "none",
                }}
              >
                <GridActionsCellItem
                  key="activated"
                  icon={
                    <Tooltip title="Habilitar" arrow>
                      <AddCircleOutline
                        style={{ fontSize: 24, color: "green" }}
                      />
                    </Tooltip>
                  }
                  label="Habilitar"
                  onClick={openStatusValue(params)}
                />
              </Grid>
            </Grid>,
          );
          return actions;
        },
      },
    ],
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    RefreshTable();
  }, []);

  // Función para eliminar acentos de una cadena de texto
  const removeAccents = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const handleSearchChange = (event) => {
    const searchValue = event.target.value;
    setSearchText(searchValue);

    if (searchValue.trim() !== "") {
      const searchLower = removeAccents(searchValue.toLowerCase());

      resultSearch = rows.filter((item) => {
        // Búsqueda por nombre de proveedor
        const nameMatch = removeAccents(
          item.companyName.toLowerCase() || "",
        ).includes(searchLower);

        const documentMatch = item.documentId
          ?.toLowerCase()
          .includes(searchLower);

        const emailMatch = item.email?.toLowerCase().includes(searchLower);

        return nameMatch || documentMatch || emailMatch;
      });

      setRows(resultSearch);
    } else {
      setRows(rowsResponse);
    }
  };

  const RefreshTable = async () => {
    setSearchText("");
    setError(false);
    setLoader(true);

    const url = `${urlServices}clients/list`;

    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${keyAuthorization}`,
        },
      });

      if (response.status === 200) {
        console.log(response.data);
        setRows(response.data);
        setRowsResponse(response.data);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        setMensageSystem("La sesión ha expirado, vuelva a iniciar sesión ...");
        setError(true);
        setTimeout(() => {
          localStorage.clear();
          setReturnLogin(true);
        }, 4000);
      } else if (error.response?.status === 500) {
        setRows([]);
        setMensageSystem("Error en la consulta con el servidor.");
        setError(true);
      } else {
        console.error("Error en la solicitud:", error);
        setRows([]);
        setMensageSystem("Error al realizar la solicitud.");
        setError(true);
      }
    } finally {
      setLoader(false);
    }
  };

  const openStatusValue = (data) => () => {
    setIdRow({ id: data.row.id, status: 1 });
    setOpenStatus(true);
  };

  const openStatusDeleteValue = (data) => () => {
    setIdRow({ id: data.row.id, status: 0 });
    setOpenStatus(true);
  };

  const openEditValue = (data) => () => {
    setIdRow(data);
    setOpenEdit(true);
  };

  const handleTokenValue = (data) => () => {
    setIdRow(data);
    setOpenToken(true);
  };

  const handleCloseEdit = () => setOpenEdit(false);
  const handleCloseNew = () => setOpenNew(false);
  const handleCloseStatus = () => setOpenStatus(false);
  const handleCloseToken = () => setOpenToken(false);

  if (returnLogin) {
    return <Navigate to="/" />;
  }

  return (
    <Fragment>
      <Card
        sx={{ padding: "15px 20px", margin: { xs: "60px 0", sm: "10px 0" } }}
        variant="outlined"
      >
        {loader ? (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <center>
                <img
                  alt="loaderGif"
                  src={loaderGif}
                  style={{ width: 60, margin: "20% 0" }}
                />
              </center>
            </Grid>
          </Grid>
        ) : (
          <Fragment>
            <Grid container>
              {error && <Alert severity="error">{mensageSystem}</Alert>}
              <Grid item xs={12} sm={12} sx={{ mb: 4 }}>
                <div className={classes.cardTitleBlack}>
                  <ListOutlined className={classes.iconFilter} /> Listado de
                  clientes
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                {/* Campo de búsqueda */}
                <TextField
                  variant="outlined"
                  value={searchText}
                  onChange={handleSearchChange}
                  sx={{ marginBottom: 3, width: { xs: "100%", sm: 300 } }}
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <Search
                        position="start"
                        style={{
                          color: "gray",
                          fontSize: 22,
                          marginRight: 10,
                        }}
                      />
                    ),
                  }}
                  fullWidth
                  autoComplete="off"
                  placeholder="Buscar"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <div style={{ float: "right" }}>
                  <ButtonStyle0
                    onClick={(event) => {
                      setOpenNew(true);
                    }}
                    endIcon={<Add />}
                  >
                    Agregar cliente
                  </ButtonStyle0>
                </div>
              </Grid>

              {rows.length === 0 ? (
                <Grid item xs={12} sm={12}>
                  <center>
                    <img
                      alt="loaderGif"
                      src={noDataImg}
                      style={{ width: 350, marginTop: 40 }}
                    />
                    <ParagraphTextPage
                      style={{ fontSize: 18, margin: "5px 0 70px 0" }}
                    >
                      No hay registros para mostrar
                    </ParagraphTextPage>
                  </center>
                </Grid>
              ) : (
                <Grid item xs={12} sm={12}>
                  <Box
                    sx={{
                      "& .super-app.celAll": {
                        fontSize: 14,
                        color: blackColor,
                        // whiteSpace: "normal !important",
                        // wordWrap: "break-word !important",
                        //backgroundColor: 'rgba(255, 7, 0, 0.55)',
                      },
                      "& .super-app.celActions": {
                        backgroundColor: "rgb(242, 242, 242)",
                      },
                      "& .super-app-theme--header": {
                        backgroundColor: "rgb(242, 242, 242)",
                      },
                      marginTop: 2,
                      width: "100%",
                      // height: '600px',
                    }}
                  >
                    <ThemeProvider theme={theme}>
                      <DataGrid
                        rows={rows}
                        columns={state.columns}
                        loading={loader}
                        initialState={{
                          pagination: {
                            paginationModel: { page: 0, pageSize: 10 },
                          },
                        }}
                        pageSizeOptions={[5, 10, 20, 50]}
                        disableRowSelectionOnClick={true}
                        checkboxSelection={false}
                        rowHeight={120}
                        sx={{
                          [`& .${gridClasses.cell}`]: {
                            display: "flex",
                            alignItems: "center", // Alineación vertical
                            // justifyContent: 'center', // Alineación horizontal
                            //wordWrap: 'break-word !important',
                            //whiteSpace: 'normal !important',
                          },
                          /* [`& .${gridClasses.columnHeaderTitle}`]: {
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                },*/
                        }}
                        getRowHeight={() => "auto"}
                        // autoHeights
                        autoWidth
                      />
                    </ThemeProvider>
                  </Box>
                </Grid>
              )}
            </Grid>
          </Fragment>
        )}
      </Card>
      {openStatus && (
        <StatusClientAdmin
          open={openStatus}
          exit={handleCloseStatus}
          id={idRow}
          callBackRefresh={RefreshTable}
        />
      )}
      {openNew && (
        <NewClientsAdmin
          open={openNew}
          exit={handleCloseNew}
          callBackRefresh={RefreshTable}
        />
      )}
      {openEdit && (
        <EditClientsAdmin
          open={openEdit}
          exit={handleCloseEdit}
          callBackRefresh={RefreshTable}
          id={idRow}
        />
      )}
      {openToken && (
        <TokenKeysAdmin
          open={openToken}
          exit={handleCloseToken}
          callBackRefresh={RefreshTable}
          id={idRow}
        />
      )}
    </Fragment>
  );
}
